export const environment = {
  production: true,
  name: 'Production',
  api_url: 'https://royal-ipay-api-a4hsa6bjdwc7cubb.southafricanorth-01.azurewebsites.net',
  app_domain: 'https://www.royalipay.tech',
};
